import { createAction, createAsyncAction } from 'services/actionConfigs';
import { PREFIX_ACTIONS } from './constants';
import { ICouponReceiveDiscountSetting, ICouponReferralSetting } from '../types';

const getCouponReceiveDiscountSetting = createAsyncAction<string, ICouponReceiveDiscountSetting>(PREFIX_ACTIONS + 'getCouponReceiveDiscountSetting');
const getReferralDiscountExitsCustomer = createAsyncAction<string, ICouponReferralSetting>(PREFIX_ACTIONS + 'getReferralDiscountExitsCustomer');

const couponActions = {
  getCouponReceiveDiscountSetting,
  getReferralDiscountExitsCustomer
};

export default couponActions;

